/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { TrademarkRequestList200ResponseMeta } from './TrademarkRequestList200ResponseMeta'
import {
  TrademarkRequestList200ResponseMetaFromJSON,
  TrademarkRequestList200ResponseMetaFromJSONTyped,
  TrademarkRequestList200ResponseMetaToJSON,
} from './TrademarkRequestList200ResponseMeta'
import type { TrademarkRequestList200ResponseData } from './TrademarkRequestList200ResponseData'
import {
  TrademarkRequestList200ResponseDataFromJSON,
  TrademarkRequestList200ResponseDataFromJSONTyped,
  TrademarkRequestList200ResponseDataToJSON,
} from './TrademarkRequestList200ResponseData'
import type { TrademarkRequestList200ResponsePagination } from './TrademarkRequestList200ResponsePagination'
import {
  TrademarkRequestList200ResponsePaginationFromJSON,
  TrademarkRequestList200ResponsePaginationFromJSONTyped,
  TrademarkRequestList200ResponsePaginationToJSON,
} from './TrademarkRequestList200ResponsePagination'

/**
 *
 * @export
 * @interface TrademarkRequestList200Response
 */
export interface TrademarkRequestList200Response {
  /**
   *
   * @type {boolean}
   * @memberof TrademarkRequestList200Response
   */
  status: boolean
  /**
   *
   * @type {TrademarkRequestList200ResponseData}
   * @memberof TrademarkRequestList200Response
   */
  data: TrademarkRequestList200ResponseData
  /**
   *
   * @type {TrademarkRequestList200ResponsePagination}
   * @memberof TrademarkRequestList200Response
   */
  pagination?: TrademarkRequestList200ResponsePagination
  /**
   *
   * @type {TrademarkRequestList200ResponseMeta}
   * @memberof TrademarkRequestList200Response
   */
  meta?: TrademarkRequestList200ResponseMeta
}

/**
 * Check if a given object implements the TrademarkRequestList200Response interface.
 */
export function instanceOfTrademarkRequestList200Response(
  value: object
): value is TrademarkRequestList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function TrademarkRequestList200ResponseFromJSON(
  json: any
): TrademarkRequestList200Response {
  return TrademarkRequestList200ResponseFromJSONTyped(json, false)
}

export function TrademarkRequestList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TrademarkRequestList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: TrademarkRequestList200ResponseDataFromJSON(json['data']),
    pagination:
      json['pagination'] == null
        ? undefined
        : TrademarkRequestList200ResponsePaginationFromJSON(json['pagination']),
    meta:
      json['meta'] == null
        ? undefined
        : TrademarkRequestList200ResponseMetaFromJSON(json['meta']),
  }
}

export function TrademarkRequestList200ResponseToJSON(
  value?: TrademarkRequestList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: TrademarkRequestList200ResponseDataToJSON(value['data']),
    pagination: TrademarkRequestList200ResponsePaginationToJSON(
      value['pagination']
    ),
    meta: TrademarkRequestList200ResponseMetaToJSON(value['meta']),
  }
}
